/* eslint-disable no-template-curly-in-string */
import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"
import {StyledContentBannerContainer} from "./components"

interface props {
    realm: string
    territory: string
    language: string
    contentBannerCmsPath: string
    isExcluded: boolean
    enableContentBanner: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    coreMediaAuthTokenName: string
    coreMediaAuthTokenValue: string
}

export const ContentBanner = memo(
    ({
        realm,
        territory,
        language,
        contentBannerCmsPath,
        isExcluded,
        enableContentBanner,
        templating,
        coreMediaAuthTokenName,
        coreMediaAuthTokenValue,
    }: props) => {
        const isEmptyPath =
            contentBannerCmsPath === undefined ||
            contentBannerCmsPath === null ||
            contentBannerCmsPath.match(/^ *$/) !== null

        const ComponentName = useTemplatedComponent(templating, MANIFEST as any)
        const cmsAuthHeader =
            coreMediaAuthTokenName && coreMediaAuthTokenValue
                ? `appendheader="${coreMediaAuthTokenName}: ${coreMediaAuthTokenValue}"`
                : ""
        const contentBannerAbsolutePath = contentBannerCmsPath
            .replace("${realm}", realm)
            .replace("${language}", language)
            .replace("${territory}", territory)
        const dangerousHTML = {
            __html: `
            <esi:choose>
                <esi:when test="$(QUERY_STRING{'excludeContentBanner'})!='true'">
                    <esi:include src="${contentBannerAbsolutePath}" onerror="continue" ${cmsAuthHeader}/>
                </esi:when>
            </esi:choose>
        `,
        }
        return isExcluded || !enableContentBanner || isEmptyPath ? (
            <style>
                {`
              :root {
                --next-header-height: calc(5.5rem + var(--next-header-branchio-height, 0px));
              }
            `}
            </style>
        ) : (
            <Suspense>
                <ComponentName />
                {/* suppressHydrationWarning added to suppress the warning related to hydration mismatch 
                    as the ESI will be resolved by Akamai and will be different on the client */}
                <StyledContentBannerContainer
                    id="header-content-banner"
                    data-testid="header-content-banner"
                    dangerouslySetInnerHTML={dangerousHTML}
                    suppressHydrationWarning
                />
            </Suspense>
        )
    },
)
ContentBanner.displayName = "ContentBanner"

export default connect(ContentBanner)
